import React from "react";
import Navbar from "../Navbar/Navbar.component";
import Topbar from "../Topbar/Topbar.component";

function Header(props) {
  return (
    <div>
      <div className="d-none d-lg-block">
        <Topbar />
      </div>
      <div className="d-block d-lg-none">
        <Topbar />
      </div>
      <Navbar
        handleShowCart={props.handleShowCartModal}
        handleLoginModal={props.handleLoginModal}
        loginModal={props.loginModal}
        RegisterModal={props.RegisterModal}
        handleRegisterModal={props.handleRegisterModal}
      />
    </div>
  );
}

export default Header;
